<Modal :value="visible" width="75" :title="title" :closable="false" :mask-closable="false" :scrollable="true"
    :mask="true">
    <Form ref="form" :rules="rules" :model="dto" label-position="right" :label-width="120">
        <Row :gutter="16">
            <Col :xxl="6" :xl="8" :lg="12" span="24">
            <FormItem label="全称：" prop="displayName">
                <Input v-model="dto.displayName"></Input>
            </FormItem>
            </Col>
            <Col :xxl="6" :xl="8" :lg="12" span="24">
            <FormItem label="节点代码：" prop="daiMa">
                <Input v-model="dto.daiMa"></Input>
            </FormItem>
            </Col>
            <Col :xxl="6" :xl="8" :lg="12" span="24">
            <FormItem label="类型：" prop="unitType">
                <Select v-model="dto.unitType" :transfer="true">
                    <Option value="Group" v-if="!dto.parentId">集团</Option>
                    <Option value="Company" v-if="['Group','CostCenter','Company'].indexOf(parentType)>=0">公司</Option>
<!--                    <Option value="CostCenter" v-if="['Group','Company'].indexOf(parentType)>=0">中心</Option>-->
<!--                    <Option value="Project" v-if="['Group','CostCenter','Company','Unit'].indexOf(parentType)>=0">项目-->
<!--                    </Option>-->
                    <Option value="Unit"
                        v-if="['Group','CostCenter','Project','Company','Unit'].indexOf(parentType)>=0">部门</Option>
                    <Option value="Station"
                        v-if="['Group','CostCenter','Project','Company','Unit','Station'].indexOf(parentType)>=0">岗位
                    </Option>
                </Select>
            </FormItem>
            </Col>
            <Col :xxl="6" :xl="8" :lg="12" span="24" v-if="dto.unitType == 'Station'">
            <FormItem label="权限范围：" prop="dataRangeType">
                <Select v-model="dto.dataRangeType" :transfer="true">
                    <Option :value="0">全部</Option>
                    <Option :value="1">本部门及下属部门</Option>
                    <Option :value="2">本人</Option>
                    <Option :value="3">本项目及下属部门</Option>
                    <Option :value="4">本中心及下属部门</Option>
                    <Option :value="5">本公司及下属部门</Option>
                    <Option :value="9">指定范围及下属部门</Option>
                </Select>
            </FormItem>
            </Col>
            <Col :xxl="6" :xl="8" :lg="12" span="24">
            <FormItem label="排序号：" prop="sortIndex">
                <InputNumber :precision="0" v-model="dto.sortIndex"></InputNumber>
            </FormItem>
            </Col>
            <Col :lg="12" span="24" v-if="dto.unitType == 'Station' && dto.dataRangeType == 9">
            <FormItem label="指定权限范围：">
                <OrganizationSelect ref="organizationSelect" :excludeTypes="['Station']" v-model="selectedUnitIds"
                    :multiple="true">
                </OrganizationSelect>
            </FormItem>
            </Col>
        </Row>
    </Form>
    <div slot="footer">
        <Button @click="handleCancelClick">取消</Button>
        <Button @click="handleSaveClick" :loading="saving" type="primary">保存</Button>
    </div>
</Modal>
